import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import datePickerMessages from './DatePicker';

var messages = _objectSpread(_objectSpread({}, datePickerMessages), {}, {
  placeholder: '请选择时间',
  quickSelect: '快速选择',
  customTime: '自定义时间',
  now: '此刻',
  confirm: '确认'
});

export default messages;